import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "../../../../components/customComponents/ModalComponent/ModalComponent.jsx";
import useAuth from "../../../../../app/hooks/useAuth.js";
import { createMessage } from "../../../../../app/redux/slices/app/messageSlice.js";
import { CircularProgress } from "@mui/material";

const MessageForCentricUser = () => {
  return (
    <>
      <div className="post d-flex flex-column-fluid">
        <div id="kt_content_container" className="container-fluid">
          <div className="row min-h-100 justify-content-center">
            <div className="col-lg-7">
              <div className="card card-custom card-xxl-stretch message-box-card">
                <div className="card-body">
                  <div className="mb-5 d-flex justify-content-between align-items-stretch with_hr_tabs gap-10px">
                    <div className="custom-search">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Topic/Title"
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                        />
                        <span className="input-group-text" id="basic-addon1">
                          <i className="fa-regular fa-magnifying-glass"></i>
                        </span>
                      </div>
                    </div>
                    <div className="head_btn align-items-center d-flex gap-10px">
                      <button className="btn btn-custom electric_cobalt min-h-55px">
                        + New Message{" "}
                      </button>
                    </div>
                  </div>
                  <div className="card-body-content">
                    <div className="d-flex flex-column gap-10px">
                      <div className="message">
                        <div className="subject">Test Purpose</div>
                        <div className="text">
                          Test Message Hi this is only for testing purpose.
                        </div>
                        <div className="time">09:07 am</div>
                        <div className="card card-custom comments">
                          <div className="card-header min-h-1px">
                            <p className="text-blue m-0">
                              <i className="fa-sharp fa-solid fa-comment me-1"></i>{" "}
                              22 Comments
                            </p>
                          </div>
                          <div className="card-body">
                            <div className="message readed">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="subject">Test Purpose</div>
                                <div className="time">09:07 am</div>
                              </div>
                              <div className="text">
                                Test Message Hi this is only for testing
                                purpose.
                              </div>
                            </div>
                            <div className="message readed">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="subject">Test Purpose</div>
                                <div className="time">09:07 am</div>
                              </div>
                              <div className="text">
                                Test Message Hi this is only for testing
                                purpose.
                              </div>
                            </div>
                          </div>
                          <div className="card-footer text-center">
                            <a href="javascript:void(0);">View All</a>
                          </div>
                        </div>
                        <div className="comment">
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              placeholder="Add New Comment Here..."
                              id="exampleFormControlTextarea1"
                              rows="3"
                            ></textarea>
                          </div>
                          <div className="text-end">
                            <button className="btn btn-custom luminous_fibre">
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="message readed">
                        <div className="subject">Test Purpose</div>
                        <div className="text">
                          Test Message Hi this is only for testing purpose.
                        </div>
                        <div className="time">09:07 am</div>
                        <div className="comment">
                          <p className="text-light">
                            <i className="fa-sharp fa-solid fa-comment me-1"></i> 2
                            Comments
                          </p>
                        </div>
                      </div>
                      <div className="message">
                        <div className="subject">Test Purpose</div>
                        <div className="text">
                          Test Message Hi this is only for testing purpose.
                        </div>
                        <div className="time">09:07 am</div>
                        <div className="comment">
                          <p className="text-light">
                            <i className="fa-sharp fa-solid fa-comment me-1"></i> 1
                            Comment
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="card card-custom card-xxl-stretch message-box-card">
                <div className="card-body">
                  <div className="card-body-content">
                    <div className="d-flex flex-column gap-10px">
                      <div className="message readed p-0">
                        <div className="subject">Test Purpose</div>
                        <div className="text">
                          Test Message Hi this is only for testing purpose.
                        </div>
                        <div className="time">09:07 am</div>
                        <div className="card card-custom comments border-0">
                          <div className="card-header min-h-1px px-0">
                            <p className="text-light m-0">
                              <i className="fa-sharp fa-solid fa-comment me-1"></i>{" "}
                              22 Comments
                            </p>
                          </div>
                          <div className="card-body p-0">
                            <div className="message readed">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="subject">Test Purpose</div>
                                <div className="time">09:07 am</div>
                              </div>
                              <div className="text">
                                Test Message Hi this is only for testing
                                purpose.
                              </div>
                            </div>
                            <div className="message readed">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="subject">Test Purpose</div>
                                <div className="time">09:07 am</div>
                              </div>
                              <div className="text">
                                Test Message Hi this is only for testing
                                purpose.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="comment">
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              placeholder="Add New Comment Here..."
                              id="exampleFormControlTextarea1"
                              rows="3"
                            ></textarea>
                          </div>
                          <div className="text-end">
                            <button className="btn btn-custom luminous_fibre">
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageForCentricUser;
